import { render } from "./Show.vue?vue&type=template&id=b4920d9c&scoped=true&lang=pug"
import script from "./Show.vue?vue&type=script&lang=ts"
export * from "./Show.vue?vue&type=script&lang=ts"

import "./Show.vue?vue&type=style&index=0&id=b4920d9c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b4920d9c"

export default script